export default "__VITE_ASSET__C0d2EyYN__"